/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_TitleInputs */

const en_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Title`)
};

const es_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título del anuncio`)
};

const fr_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre de l'annonce`)
};

const de_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat-Titel`)
};

const ja_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品タイトル`)
};

const zh_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品标题`)
};

const ar_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عنوان الإعلان`)
};

const id_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul Listing`)
};

const it_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo dell'Annuncio`)
};

const ru_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок объявления`)
};

const pt_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título do Anúncio`)
};

const ko_listing_title = /** @type {(inputs: Listing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 제목`)
};

/**
* | output |
* | --- |
* | "Listing Title" |
*
* @param {Listing_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_title = /** @type {((inputs?: Listing_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_title(inputs)
	if (locale === "es") return es_listing_title(inputs)
	if (locale === "fr") return fr_listing_title(inputs)
	if (locale === "de") return de_listing_title(inputs)
	if (locale === "ja") return ja_listing_title(inputs)
	if (locale === "zh") return zh_listing_title(inputs)
	if (locale === "ar") return ar_listing_title(inputs)
	if (locale === "id") return id_listing_title(inputs)
	if (locale === "it") return it_listing_title(inputs)
	if (locale === "ru") return ru_listing_title(inputs)
	if (locale === "pt") return pt_listing_title(inputs)
	return ko_listing_title(inputs)
});